import { StyledActionButton } from './styles';

const ActionButtons = ({ mobile, onSelect, performActionOptions }) => (
  <>
    {performActionOptions.map((option) => (
      <StyledActionButton
        key={option.value}
        color="blue"
        variant="outline"
        onClick={() => onSelect(option)}
      >
        {option.label}
      </StyledActionButton>
    ))}
    {/* These spacers allow for up to four columns of buttons */}
    {!mobile && (
      <>
        <span />
        <span />
      </>
    )}
  </>
);

export default ActionButtons;
